import './view.scss';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.latest-updates').forEach(block => {
        const tabs = [...block.querySelectorAll('.tabs > .tab')];
        const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
        if (!tabs.length || panels.some(panel => !panel)) return;
        const select = selected => {
            tabs.forEach((tab, index) => {
                const active = index === selected;
                tab.classList.toggle('active', active);
                tab.setAttribute('aria-selected', String(active));
                tab.tabIndex = active ? 0 : -1;
                panels[index].hidden = !active;
                panels[index].inert = !active;
                panels[index].querySelector('.resource-results')?.classList.toggle('active', active);
            });
            const panel = panels[selected];
            const slider = panel.querySelector('.swiper-container');
            if (!slider || typeof window.Swiper !== 'function') return;
            if (slider.swiper) { slider.swiper.update(); return; }
            const instance = new window.Swiper(slider, {
                slidesPerView: 'auto', spaceBetween: 25, autoHeight: true,
                // Keep a predictable article order, with no loop reordering.
                loop: false,
                navigation: { prevEl: panel.querySelector('.swiper-button-prev'), nextEl: panel.querySelector('.swiper-button-next') },
                breakpoints: { 0: { slidesPerView: 1, spaceBetween: 10 }, 768: { slidesPerView: 2, spaceBetween: 15 }, 1024: { slidesPerView: 3, spaceBetween: 25 } },
            });
            [instance.navigation.prevEl, instance.navigation.nextEl].flat().filter(Boolean).forEach(button => {
                button.querySelectorAll('svg').forEach(icon => {
                    icon.setAttribute('aria-hidden', 'true');
                    icon.setAttribute('focusable', 'false');
                });
            });
            panel.addEventListener('focusin', event => {
                const slide = event.target.closest('.swiper-slide');
                if (slide) slider.swiper?.slideTo([...slider.querySelectorAll('.swiper-slide')].indexOf(slide), 0);
            });
        };
        select(0);
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => select(index));
            tab.addEventListener('keydown', event => {
                let next;
                if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
                else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
                else if (event.key === 'Home') next = 0;
                else if (event.key === 'End') next = tabs.length - 1;
                else return;
                event.preventDefault();
                select(next);
                tabs[next].focus();
            });
        });
    });
});
